import {FRBase} from "#Formulas/FormulaCore/FRBase";
import {FRFactory} from "#Formulas/FormulaCore/FRFactory";

export class FRBool extends FRBase{

    constructor(Options: any, Parent: FRBase) {
        super(Options, Parent);
    }

    Parse(): any {
        return this.Options.d;
    }

}

FRFactory.AddField('BL',FRBool);